import styled from "styled-components";
import type { FormStyledProps } from "../types";

export const EmbeddedStyled = styled.div<FormStyledProps>`
  justify-content: ${({ $horizontalAlignment }) => $horizontalAlignment};
  .iframe__wrapper {
    width: var(--entity-width);
    height: var(--entity-height);
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;
